module.exports = __webpack_public_path__ + "img/thank-nav-banner.1279560f.png";